import React, { Component, SyntheticEvent, FocusEvent } from 'react';
import { inject, observer } from 'mobx-react';

import { Input as AntInput } from 'antd';

type Props = {
	record: any,
	fieldValue?: number,
	field: string,
	onChange: Function,
};

@inject((stores, props: Props) => ({
	fieldValue: props.record[props.field],
}))
@observer
export default class Input extends Component<Props> {
	render() {
		const { fieldValue, onChange } = this.props;
		return (
			<AntInput
				{...this.props}
				value={fieldValue}
				onChange={(value: any) => onChange(value)}
			/>
		);
	}
}
